var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBackbanner1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 317,
    height: 206,
    viewBox: "0 0 317 206",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.0701 147.305C50.0701 147.305 45.849 137.915 21.5781 137.445C27.0889 168.432 50.0701 157.868 50.0701 157.868V147.305Z",
    fill: "#84D9C6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.25 147.305C49.25 147.305 53.471 137.915 77.7419 137.445C72.2312 168.432 49.25 157.868 49.25 157.868V147.305Z",
    fill: "#84D9C6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2516 195.785L44.4376 194.846C44.5548 194.612 51.9416 170.667 44.3203 114.797L47.3688 114.445C54.9901 171.137 47.6033 194.846 47.2516 195.785Z",
    fill: "#138468"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6264 126.061C41.6264 126.061 25.2113 117.963 38.9296 92.2578C63.5523 111.272 48.1924 130.287 48.1924 130.287L41.6264 126.061Z",
    fill: "#84D9C6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M165.557 127.003C165.557 127.003 160.632 116.087 132.375 115.5C138.824 151.534 165.557 139.209 165.557 139.209V127.003Z",
    fill: "#84D9C6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M164.734 127.003C164.734 127.003 169.659 116.087 197.916 115.5C191.468 151.534 164.734 139.209 164.734 139.209V127.003Z",
    fill: "#84D9C6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M162.392 183.338L159.109 182.281C159.227 182.047 167.786 154.229 158.992 89.2039L162.51 88.7344C171.303 154.698 162.744 182.281 162.392 183.338Z",
    fill: "#138468"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M155.821 102.351C155.821 102.351 136.709 92.9616 152.655 63.0312C181.264 85.2149 163.442 107.281 163.442 107.281L155.821 102.351Z",
    fill: "#84D9C6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M272.139 76.764C272.139 76.764 266.276 63.6181 232.391 63.0312C240.129 106.225 272.139 91.4357 272.139 91.4357V76.764Z",
    fill: "#84D9C6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M271.086 76.764C271.086 76.764 276.948 63.6181 310.834 63.0312C303.095 106.225 271.086 91.4357 271.086 91.4357V76.764Z",
    fill: "#84D9C6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M268.276 144.25L264.289 142.959C264.406 142.607 274.724 109.273 264.172 31.4541L268.393 30.8672C279.063 109.86 268.745 142.959 268.276 144.25Z",
    fill: "#138468"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M260.416 47.1842C260.416 47.1842 237.434 35.9164 256.664 0C291.018 26.5265 269.561 53.0529 269.561 53.0529L260.416 47.1842Z",
    fill: "#84D9C6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M307.312 204.697H221.25V188.852H307.312V204.697Z",
    fill: "#FFD42F"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M316.929 190.025H230.867V174.18H316.929V190.025Z",
    fill: "#FFEAA5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M300.281 175.353H214.219V159.508H300.281V175.353Z",
    fill: "#FFD42F"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M306.375 160.681H220.312V144.836H306.375V160.681Z",
    fill: "#FFEAA5"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M313.882 146.01H227.82V130.164H313.882V146.01Z",
    fill: "#FFD42F"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M193.937 205.283H107.875V189.438H193.937V205.283Z",
    fill: "#FFD42F"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M201.554 190.611H115.492V174.766H201.554V190.611Z",
    fill: "#FFEAA5"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0621 205.283H0V189.438H86.0621V205.283Z",
    fill: "#FFD42F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBackbanner1);
export default __webpack_public_path__ + "static/media/icon_backbanner_1.8a2a02d71cec8c9581265665696de424.svg";
export { ForwardRef as ReactComponent };